import { firestorePaths } from '../utils/paths';
import BaseDocument from './BaseDocument';

/**
 * Class representing a Facebook Pixel configuration.
 * Manages Facebook Pixel settings for coaches, including pixel ID and access token.
 *
 * @class FacebookPixel
 * @extends BaseDocument
 */
class FacebookPixel extends BaseDocument {
  constructor(coachId, opts) {
    super(`${firestorePaths.FACEBOOK_PIXEL_CONFIG}/${coachId}`, opts);
  }

  /**
   * Get the Facebook Pixel ID.
   * @return {string} The Facebook Pixel ID, or an empty string if not set
   */
  get pixelId() {
    return this.data?.pixelId || '';
  }

  /**
   * Get the Facebook Pixel access token.
   * @return {string} The Facebook Pixel access token, or an empty string if not set
   */
  get accessToken() {
    return this.data?.accessToken || '';
  }

  /**
   * Sets the Facebook Pixel configuration
   * @param {string} pixelId - The Facebook Pixel ID
   * @param {string} accessToken - The Facebook Pixel access token
   * @returns {Promise<void>}
   */
  setFacebookPixelConfig(pixelId, accessToken) {
    return this.updateFields({
      pixelId,
      accessToken,
    });
  }

  /**
   * Gets Facebook Pixel configuration by coach ID
   * @param {string} coachId - The coach ID (which is the document ID)
   * @returns {Promise<FacebookPixel>} The Facebook Pixel document (empty instance if doc doesn't exist in DB)
   */
  static async getFacebookPixelConfigByCoachId(coachId) {
    const pixelDoc = new FacebookPixel(coachId);
    await pixelDoc.init();
    return pixelDoc;
  }
}

export default FacebookPixel;
